import { QuestionBase } from './question-base.model';

export class FileUploaderQuestion extends QuestionBase<string> {
   controlType = 'fileuploader';
   visible: boolean;
   resource: string;
   multiple: boolean;
   formatsAllowed: string;
   maxSize: number;
   formAction: any;
   id: string;
   formSubmit: boolean;
   crop_image: boolean;
   compress_image: boolean;
   delete_document: string;
   multipleImageUpload: boolean;
   config: any;
   capture_image: boolean;
   icon_with_text: boolean;
   s3Document: boolean;
   copyURLbtn: boolean;
   /** Control that receives the uploaded file's name. Defaults to `document_name`. */
   document_name_field: string;
   constructor(options: {} = {}) {
      super(options);
      this.id = options['id'];
      this.resource = options['resource'];
      // this.controlType = options['resource'];
      this.conditions = options['conditions'] || '';
      this.visible = (options['visible'] == undefined) ? true : options['visible'];
      this.multiple = options['multiple'];
      this.formatsAllowed = options['formatsAllowed'];
      this.maxSize = options['maxSize'];
      this.formAction = options['formAction'];
      this.formSubmit = (options['formSubmit'] == undefined) ? false : options['formSubmit'];
      this.crop_image = (options['crop_image'] == undefined) ? true : options['crop_image'];
      this.compress_image = (options['compress_image'] == undefined) ? true : options['compress_image'];
      this.delete_document = (options['delete_document'] == undefined) ? "delete" : options['delete_document'];
      this.multipleImageUpload = (options['multipleImageUpload'] == undefined) ? false : options['multipleImageUpload'];
      this.config = options['config'];
      this.capture_image = (options['capture_image'] == undefined) ? false : options['capture_image'];
      this.icon_with_text = (options['icon_with_text'] == undefined) ? false : options['icon_with_text'];
      this.s3Document = (options['s3Document'] == undefined) ? false : options['s3Document'];
      this.copyURLbtn = (options['copyURLbtn'] == undefined) ? false : options['copyURLbtn'];
      this.document_name_field = (options['document_name_field'] == undefined) ? 'document_name' : options['document_name_field'];
   }
}